import { useEffect, useState } from "react";

import apiClient from "../../api/client";
import { isCanceledRequest } from "../../helpers/isCanceledRequest";

/**
 * The member's Heritage Credit balance for the header pill, or null while it loads, when it fails, or when `enabled` is false.
 * `enabled` is a build flag, fixed for the page's life. Disabled means no request at all: the endpoint creates a wallet row on
 * first read, so it is not called while the feature is off.
 *
 * @param {boolean} enabled
 * @returns {?number}
 */
export const useWalletBalance = enabled => {
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const controller = new AbortController();

    apiClient({ method: "get", url: "/members/api-v2/heritage-credits/wallet-balance", signal: controller.signal })
      .then(response => {
        const value = Number(response?.data?.data?.balance ?? response?.data?.balance);

        setBalance(Number.isFinite(value) ? value : null);
      })
      .catch(error => {
        if (!isCanceledRequest(error)) {
          setBalance(null);
        }
      });

    return () => controller.abort();
  }, [enabled]);

  return balance;
};
